import { DayOfWeek } from "./view"

export interface SettingValuePair {
	setting: Setting
	value: Value
}

export interface Setting {
	key: string
	title: string
	description: string | null
	dataType: string
	hideFromSetupPage : boolean
}

export interface Value {
	value : any | DefaultValueObject
}

export interface DefaultValueObject {
	title: string,
	dataType: null | string,
	description:string,
	isEnabled: boolean,
}

export interface TenantSetting {
	id: string | null
	tenantId: string | null
	settings: { [key: string]: any }
	isEnabled: boolean
}

export interface FirstDayOfWeekSetting {
	enabled: boolean,
	dayOfWeekSelected: DayOfWeek
}

export enum TenantSettingKeys {
	CreatePromotedWithButton = "buttonCreatePromoted",
	AllTemplatesAlwaysPromoted = "allTemplatesAlwaysPromoted",
	AllowFieldEditingInViews = "allowFieldEditInViews",
	DefaultFirstDayOfWeek = "defaultFirstDayOfWeek",
	CheckTenantSize = "checkTenantSize",
	ScheduleHideBulkCreate = "scheduleHideBulkCreate",
	ScheduleHideTimeSpan = "scheduleHideTimeSpan",
	EnabledTimezones = "timeZones",
	ShowInsightDuplicationOptionsPopup = "showInsightDuplicationOptionsPopup",
	DoNotDuplicateInsightOptionDefaults = "doNotDuplicateInsightOptionDefaults",
	InProgressTextFieldSave = "inProgressTextFieldSave",
	DisplayAreaSelectInHeader = "displayAreaSelectInHeader"
}
